var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "statisticsRootBox" }, [
    _c("div", { staticClass: "statistics_1" }, [
      _c("div", { staticClass: "statistics_content" }, [
        _c("div", [_vm._v(_vm._s(_vm.statisticsData.runningDays || 0))]),
        _vm._v(" "),
        _c("div", [_vm._v("运行天数")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "statistics_2" }, [
      _c("div", { staticClass: "statistics_content" }, [
        _c("div", [_vm._v(_vm._s(_vm.statisticsData.teachingClassCount || 0))]),
        _vm._v(" "),
        _c("div", [_vm._v("教学班")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "statistics_3" }, [
      _c("div", { staticClass: "statistics_content" }, [
        _c("div", [
          _vm._v(_vm._s(_vm.statisticsData.administrativeCount || 0))
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("行政班")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "statistics_4" }, [
      _c("div", { staticClass: "statistics_content" }, [
        _c("div", [
          _c("span", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.statisticsData.adminCount || 0) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(" (占比 " + _vm._s(_vm.adminCountPercent) + "% ) ")
          ])
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("注册管理员")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "statistics_5" }, [
      _c("div", { staticClass: "statistics_content" }, [
        _c("div", [
          _c("span", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.statisticsData.teacherCount || 0) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(" (占比 " + _vm._s(_vm.teacherCountPercent) + "% ) ")
          ])
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("注册教师")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "statistics_6" }, [
      _c("div", { staticClass: "statistics_content" }, [
        _c("div", [
          _c("span", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.statisticsData.studentCount || 0) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v(" (占比 " + _vm._s(_vm.studentCountPercent) + "% ) ")
          ])
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("注册学生")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ffff3f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ffff3f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mStatistics.vue
// module id = null
// module chunks = 